import { render, staticRenderFns } from "./ResetSettingsDialog.vue?vue&type=template&id=0ab510c4&scoped=true&"
import script from "./ResetSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./ResetSettingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab510c4",
  null
  
)

export default component.exports